import { buildHtml, ContentRoute, RouteSlotInput } from '@caritas/ui';

import { calculateOrientation } from '../../utils/image-orientation';
import { mapImage } from '../Image.mappers';

export function hasCaption(input: any | null): input is { caption: string } {
  return !!input?.caption;
}

export function hasSource(input: any | null): input is { source: string } {
  return !!input?.source;
}

export const buildCopyrightText = (input: any | null): string => {
  const copyrightParts = [];
  if (hasCaption(input)) {
    copyrightParts.push(input.caption);
  }
  if (hasSource(input)) {
    copyrightParts.push(`©&nbsp;${input.source}`);
  }
  return copyrightParts.length > 0 ? copyrightParts.join(' ') : '';
};

export function mapImageBlock(
  input: BlockImageFragment,
): RouteSlotInput<typeof ContentRoute, 'body', 'Image'> {
  return {
    key: 'Image',
    input: () => {
      const image = input.image?.image;
      const styles = [
        ...(image?.styles
          .filter((style) => style.id === 'content')
          .map((style) => style.derivatives)[0] || []),
      ];

      const largest = styles.sort((a, b) => (a.width > b.width ? 1 : -1))[
        styles.length - 1
      ];
      const copyright = buildCopyrightText(input.image);

      return [
        {
          orientation: largest
            ? calculateOrientation({
                width: largest.width,
                height: largest.height,
              })
            : 'landscape',
          Description:
            input.displayDescription && copyright
              ? buildHtml(copyright)
              : undefined,
          Image: mapImage({
            image,
            preset: 'content',
            caption:
              input.displayDescription && hasCaption(image)
                ? image.caption
                : undefined,
          }),
        },
        200,
      ];
    },
  };
}
